import { createRequiredContext } from '../../../libs/context'

type IsOpenContextType = {
  isOpen: boolean
}

const [useDisclosureSectionContext, Provider] =
  createRequiredContext<IsOpenContextType>('DisclosureSection')

export { Provider, useDisclosureSectionContext }
